const config = {
  gatsby: {
    pathPrefix: '/docs',
    siteUrl: 'https://focusbox.io',
    trailingSlash: false,
  },
  404: {
    title: 'Documentation | FocusBox',
    description: 'Documentation built with mdx. ',
  },
  header: {
    logo: 'https://d2jybm7v16arru.cloudfront.net/logo/logo-white.svg',
    logoLink: 'https://focusbox.io/',
    title: "<a class='header-link' href='https://focusbox.io/docs/'>" +
      "<span class='header-link-separator'></span>" +
      "<span class='header-link-text'>docs</span>" +
      "</a>",
    githubUrl: '',
    helpUrl: '',
    tweetText: '',
    social: ``,
    links: [
      { text: 'Templates', link: 'https://focusbox.io/templates' },
      { text: 'Blog', link: 'https://focusbox.io/blog/' },
      { text: 'Login', link: 'https://focusbox.io/login' },
      { text: 'Sign Up', link: 'https://focusbox.io/pricing' },
    ],
    search: {
      enabled: true,
      indexName: 'Docs',
      algoliaAppId: 'SXP76P013X',
      algoliaSearchKey: 'bff1330487a5ce5f49297adca9741725',
      algoliaAdminKey: '3299dbe8838e252d84b7ae3c8198d14a',
    },
  },
  sidebar: {
    forcedNavOrder: [
      '/guides',
      '/features',
      '/integrations',
      '/knowledge-base',
      '/pricing',
    ],
    collapsedNav: [
      '/knowledge-base',
    ],
    links: [
      { text: 'Get Started Now', link: 'https://focusbox.io/pricing' },
    ],
    linksNormal: [
      { text: '© FocusBox - Privacy Policy', link: 'https://focusbox.io/privacy' },
    ],
    frontline: false,
    ignoreIndex: true,
    title: false,
  },
  siteMetadata: {
    title: 'Documentation | FocusBox',
    description: 'FocusBox Documentation.',
    ogImage: 'https://d2jybm7v16arru.cloudfront.net/logo/logo-white.svg',
    docsLocation: '',
    favicon: 'https://d2woeiihr4s5r6.cloudfront.net/documentation/favicon/favicon.ico',
  },
  pwa: {
    enabled: false, // disabling this will also remove the existing service worker.
    manifest: {
      name: 'FocusBox Documentation',
      short_name: 'FocusBox Docs',
      start_url: '/',
      background_color: '#36a509',
      theme_color: '#36a509',
      display: 'standalone',
      crossOrigin: 'use-credentials',
      icons: [
        {
          src: 'src/pwa-512.png',
          sizes: `512x512`,
          type: `image/png`,
        },
      ],
    },
  },
};

module.exports = config;
